import { useCallback, useEffect, useState } from 'react';

export const useNotesDrawerState = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [contactId, setContactId] = useState(null);

  const openDrawer = useCallback((id) => {
    setContactId(id);
    setIsOpen(true);
    document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
  }, []);

  const closeDrawer = useCallback(() => {
    setIsOpen(false);
    setContactId(null);
    document.getElementsByTagName('body')[0].style.overflowY = '';
  }, []);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape' && isOpen) {
        closeDrawer();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, closeDrawer]);

  useEffect(
    () => () => {
      document.getElementsByTagName('body')[0].style.overflowY = '';
    },
    [],
  );

  return {
    isOpen,
    contactId,
    openDrawer,
    closeDrawer,
  };
};
